import { render } from "./ApiGroups.vue?vue&type=template&id=99ded7ac"
import script from "./ApiGroups.vue?vue&type=script&lang=js"
export * from "./ApiGroups.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__